'use strict';

/* globals , $, window */

$(window).on('action:ajaxify.end', onLoad);

function onLoad() {
	if (window.location.pathname === '/hash-file-manager') {
		require(['file-functions'], function (fileFunctions) {
			fileFunctions.setupUploader();
			fileFunctions.setupCopyFile();
			fileFunctions.setupCopyFileForPost();
			fileFunctions.setupDeleteFile();
		});
	}
}
